<template>
  <svg
    width="5.6444mm"
    height="9.8474mm"
    version="1.1"
    viewBox="0 0 20 34.892"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(-814.6 -274.39)">
      <g transform="matrix(1.1856 0 0 1.1856 -151.18 -57.398)">
        <path
          d="m817.11 282.97c-1.2582 1.3428-2.0462 3.2988-2.0156 5.1387 0.0639 3.8448 1.7969 5.3002 4.5684 10.592 0.99832 2.3285 2.0403 4.7924 3.0312 8.873 0.13772 0.60193 0.27203 1.161 0.33416 1.2095 0.0621 0.0485 0.19644-0.51262 0.33416-1.1146 0.99098-4.0807 2.0329-6.5426 3.0312-8.8711 2.7714-5.2916 4.5044-6.747 4.5684-10.592 0.0306-1.8399-0.75942-3.7978-2.0176-5.1406-1.4372-1.5339-3.605-2.6691-5.9162-2.7166-2.3112-0.0475-4.4809 1.0877-5.9181 2.6216z"
          fill="#ff4646"
          stroke="#d73534"
        />
        <circle
          cx="823.03"
          cy="288.25"
          r="3.0355"
          fill="#590000"
          stroke-width="0"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import svg from '@/mixins/svg'
export default {
  mixins: [svg],
}
</script>
